import React from 'react';
import { Row, Col } from 'react-bootstrap';
import DatePicker from 'react-datepicker';


export default function DateRange(props) {
  const { startDate, endDate, setStartDate, setEndDate, invalidStart, invalidEnd, handleSearch } = props;

  return (
    <Row>
      <Col className="pr-1">
        <DatePicker
          selectsStart
          selected={startDate}
          startDate={startDate}
          maxDate={endDate ? endDate : ''}
          endDate={endDate}
          onChange={date => setStartDate(new Date(date))}
          onKeyPress={e => (e.key === 'Enter') ? handleSearch() : ""}
          className={`form-control ${invalidStart ? 'is-invalid' : ''}`}
          placeholderText="From"
          wrapperClassName="w-100"
        />
      </Col>
      <Col className="pl-1">
        <DatePicker
          selectsEnd
          selected={endDate}
          minDate={startDate}
          startDate={startDate}
          endDate={endDate}
          onChange={date => setEndDate(new Date(date))}
          onKeyPress={e => (e.key === 'Enter') ? handleSearch() : ""}
          className={`form-control ${invalidEnd ? 'is-invalid' : ''}`}
          placeholderText="To"
          wrapperClassName="w-100"
        />
      </Col>
    </Row>
  );
};
